import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {Field} from 'formik';
import {FormattedMessage} from "react-intl";
import AbstractModalView from '../AbstractModalView';
import Button from '../Button';
import ModalHeader from '../ModalHeader';
import Select from './Select';
import ModalOptions from './ModalOptions';
import styles from './styles.module.scss';

const CustomSelect = ({
                        field,
                        form,
                        meta,
                        subPath,
                        loadOptions,
                        label,
                        placeholder,
                        modalHeaderLabel,
                        optionsListLabel,
                        onChange,
                        ...rest
                      }) => {
  const [selected, setSelected] = useState({label: '', value: null});
  const [options, setOptions] = useState(null);

  const callback = items => setOptions(items);

  const setFieldAndCloseModal = ({form, field, value, closeModal}) => () => {
    if (onChange) onChange(value);
    form.setFieldValue(field.name, value);
    closeModal();
  };

  useEffect(() => {
    loadOptions(null, callback)
  }, [loadOptions]);

  useEffect(() => {
    if (options === null) return;

    const selected = options.filter(option => option.value === field.value.value)[0];
    setSelected(selected || {label: '', value: null});
  }, [options]);

  return (
    <AbstractModalView
      subPath={subPath}
      triggerContent={({openModal}) => (
        <Select
          onClick={openModal}
          label={label}
          placeholder={placeholder}
          field={field}
          form={form}
          meta={meta}
          value={selected}
          {...rest}
        />
      )}
      modalContent={({closeModal}) => (
        <>
          <ModalHeader onClick={closeModal}>
            <div>{modalHeaderLabel}</div>
            <Button
              onClick={setFieldAndCloseModal({form, field, value: selected, closeModal})}
              label={(
                <FormattedMessage
                  id='common.modal.button.ok'
                  defaultMessage='OK'
                />
              )}
              className={styles.btnConfirm}
              disabled={!selected.value}
            />
          </ModalHeader>
          <ModalOptions
            options={options}
            selectOption={value => setSelected(value)}
            selected={selected}
            optionsListLabel={optionsListLabel}
          />
        </>
      )}
    />
  )
};

const FieldSelectModal = ({
                            fieldId,
                            ...rest
                          }) => {

  return (
    <Field
      id={fieldId}
      name={fieldId}
    >
      {(fieldProps) => <CustomSelect subPath={fieldId} {...fieldProps} {...rest} />}
    </Field>
  )
};

FieldSelectModal.propTypes = {
  fieldId: PropTypes.string.isRequired,
  loadOptions: PropTypes.func.isRequired,
  label: PropTypes.node,
  placeholder: PropTypes.node,
  modalHeaderLabel: PropTypes.node,
  optionsListLabel: PropTypes.node,
};

export default FieldSelectModal;
